(function () {
    /* globals $, angular */
    'use strict';

    angular.module('dashboardApp').factory('AppSettings', Settings);

    function Settings() {
        return {

            paths: {
                api: 'api/',
                html: 'ui/build/html'
            }

        };
    }
})();